import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';
import { DefaultInput, IconInput } from './components';

const CustomInput = (props) => {
  return (
    <FormGroup>
      <Label for={props.inputName}>{props.labelText}</Label>
      { props.hasIcon ? <IconInput {...props} /> : <DefaultInput {...props} />}
    </FormGroup>
  );
};

CustomInput.defaultProps = {
  hasIcon: false
};

CustomInput.propTypes = {
  labelText: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired,
  inputType: PropTypes.string,
  placeholder: PropTypes.string,
  iconPosition: PropTypes.string,
  iconName: PropTypes.string,
  actionIcon: PropTypes.string
};

export default CustomInput;
